import { IconButtonController } from './icon-button.controller';
import { IconButtonProps } from './icon-button.model';

export const IconButton = (props: IconButtonProps) => {
  return <IconButtonController {...props} />;
};
